/// <summary>
/// This object provides js functions for... <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 20.5.2025<br />
/// Copyright ©: EUDT GmbH 2025 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.5.2025                                             *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DataPointNames", jQuery.common.vcBaseV4, {
    _create: function () {
      
        this._createVisual(393);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".datapoint-name");
            me._buildHtml();
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initStructure();
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                menu: {}, list: {}
            };
            //top menu for save button
            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom").css("width", "100%").css("height", "30px");
            obj.save = me._setObj("btn-save", "").css("float", "right").html(me.specific.resources.save);
            obj.wrapper.append(obj.save);

            obj = me.myHtml.list;
            obj.wrapper = me._setObj("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w25").html(me.specific.resources.lang));
            line.column.append(me._setListElement("", "w50").html(me.specific.resources.name));
         
            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table").css("max-height", "none");
            obj.wrapper.append(obj.header, obj.entries);

            me.myRoot.append(me.myHtml.menu.wrapper, me.myHtml.list.wrapper);
        

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            //save button click handler
            me.myHtml.menu.save.off("click").on("click", function () { me._save(); }).button().button("disable");

            me.myHtml.list.entries.off("keyup", ".validate").on("keyup", ".validate", function () { me._validate(); });

            me.myHtml.list.entries.off("click", ".translate").on("click", ".translate", function (e) {
                {
                    var shortcut = $(e.target).data("lang");
                    me.getData({ TypeId: 2, TranslationText: me.myData.MainName, LanguageShortcut: shortcut }, function (result) {

                        //check response content
                        if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }

                        if (result.length == 0) { alert(me.specific.resources.noTranslationFound); return ture; }
                        var input = $(e.target).siblings(".txtEnabled");

                        var text = "<b>" + me.specific.resources.shouldTranslationGetUsed + "</b><br/><br/>" + result[0]
                        //open the dialog
                        me.openAskDialog(text, { at: 'center center-20%', of: window }, function () {
                            input.val(result[0]);
                            me._validate();
                        });


                      
                    });
                   
                }
            });


        } catch (e) { me._writeErr(e); }
    },


    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);
            me.getData({ TypeId: 1 }, function (result) {

                //check response content
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                me.myData = result;
                me._generateList();
                me._validate();
                me.myHtml.menu.save.button("disable");
            });
        } catch (e) { me._writeErr(e); return false; } return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {

            //clear list
            me.myHtml.list.entries.html("");
            // first, we add static a line with the main name
            var line = me._setListItem();       
            line.column.append(me._setListElement("", "w25").html(me.specific.resources.default));
            line.column.append(me._setListElement("", "w50").html(me.myData.MainName).css("font-weight", "bold"));
            me.myHtml.list.entries.append(line.item);

            //we add lines for each active sub language
            for (var i = 0; i < me.specific.languages.length; i++) {
                if (me.specific.languages[i].ID > 2 && me.specific.languages[i].Active) {
                    me._fillRow(me.specific.languages[i]);
                }
            }
            //we use no filter - so we set everything to found
            me.myHtml.list.entries.find(".vc-list-item").addClass("found");
            me._setAltListStyle(me.myHtml.list.entries);
            return true;

        } catch (e) { me._writeErr(e);return false; }
    },

    _fillRow: function (lang) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var input, description;
            var line = me._setListItem();  
            //get an existing sub mame
            var subName = "";

            $.each(me.myData.SubNames, function (e, obj) {
                if (obj.LangId == lang.ID) { subName = obj.Name;}
            }); 

            line.column.append(me._setListElement("", "w25").html(lang.ShortCut));
            input = $("<input>", { class: "data string txtEnabled validate" }).width(350).val(subName).data("id", lang.ID).data("shortcut", lang.ShortCut);
            line.column.append(me._setListElement("", "w50").html(input).append($("<i>", { 'data-lang': lang.ShortCut, title: me.specific.resources.translation, "class": "translate fa-regular fa-language color-font-secondary vc-list-icon vc-grid-margin-left" }).css("margin-left", "5px")));
            me.myHtml.list.entries.append(line.item);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _validate: function () {
        /// <summary>
        /// This function iterates all sub language names and validates the max length
        /// </summary>
        var me = this;
        try {

            $.each(me.myHtml.list.entries.find(".validate"), function () {
                let obj = $(this);
                obj.removeClass("error");
                let val = trimAll(obj.val() + "");
                if (val.length > 60) { obj.addClass("error");  }       
            });

            let bValid = true;
            if (me.myHtml.list.entries.find(".error").length > 0) { bValid = false; }
            me.myHtml.menu.save.button(bValid ? "enable" : "disable");
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _save: function () {
        /// <summary>
        /// This function saves the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._validate();
            if (me.myHtml.menu.save.hasClass("ui-state-disabled")) return true;
            var param = { SubNames: [] }

            $.each(me.myHtml.list.entries.find(".validate"), function () {
                let obj = $(this);
                let subName = trimAll(obj.val() + "");
                if (subName.length > 0) {
                    param.SubNames.push({ LangId: parseInt(obj.data("id")), ShortCut: obj.data("shortcut"), Name: subName });
                }
            });
            console.info(param.SubNames);
            me.updateData(param, function (result) {
                me.myHtml.menu.save.button("disable");
                //check response content
                if (result == false) { me.showMessage(me.resources.err_saveData, true); return true; }
                me._fetch();
            });


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _setHeightsAndWidths: function (iColumns) {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight() - 20;

            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height", hList);

          
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.list.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});